/* ++++++++++ --------------- IMPORT COMMENTS : STYLES --------------- ++++++++++ */
import {pxToEm, themeV2, coloredScrollBar} from "@insticator/insticator-ui";

export default {
  '@global': {
    '.logsmodal': {
      maxHeight: pxToEm(400),
      overflowY: 'auto',
      extend: coloredScrollBar(themeV2.color.base.scrollbar),
      fontSize: pxToEm(14),
      padding: pxToEm(14),
      '& h4': {
        marginBottom: pxToEm(20)
      },
      '& ul': {
        marginLeft: pxToEm(8),
        color: themeV2.color.base.gray.dark,
        '& li': {
          margin: `${pxToEm(4)} ${pxToEm(16)}`
        }
      }
    }
  },
  importcomments: {
    maxWidth: pxToEm(1280),
    '& .collapsable': {
      '& .innerWrap': {
        padding: 0
      },
      '&.opened': {
        overflow: 'visible',
        '& .innerWrap': {
          padding: pxToEm(16)
        }
      }
    },
    '& .sectioncard': {
      padding: 0
    },
    '& .name-imports': {
      '& th:nth-child(1)': {
        paddingLeft: pxToEm(36)
      },
      '& tr': {
        '& td': {
          padding: pxToEm(16)
        },
        '& td:nth-child(1)': {
          minWidth: pxToEm(140),
          paddingLeft: pxToEm(36)
        },
        '& td:nth-child(2)': {
          width: pxToEm(320),
          minWidth: pxToEm(200)
        },
        '& td:nth-child(7)': {
          width: pxToEm(200),
          padding: pxToEm(4)
        }
      },
      '& ul': {
        '& li': {
          listStyle: 'none',
          fontSize: pxToEm(14),
          '& span:nth-child(1)': {
            width: pxToEm(85)
          },
          '& span:nth-child(2)': {
            color: themeV2.color.base.gray.dark
          }
        }
      }
    },
    '& .name-imports-header': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: `${pxToEm(16)} ${pxToEm(32)}`,
      paddingBottom: pxToEm(12),
      marginTop: pxToEm(8),
      '& .title': {
        margin: 0,
        '& h2': { 
          fontWeight: 700,
          fontSize: pxToEm(16),
          lineHeight: pxToEm(24),
          minWidth: pxToEm(150)
        }
      },
      '& .button': {
        width: 'auto',
        padding: `0 ${pxToEm(16)}`,
        height: pxToEm(34),
        marginRight: pxToEm(8),
        fontSize: themeV2.typography.size.xsmall.fontSize,
        '& i': {
          fontSize: themeV2.typography.size.xsmall.fontSize,
        }
      }
    },
    '& .daterange, & .importsource, & .status': {
      color: themeV2.color.primary.main,
      marginBottom: pxToEm(4),
      fontSize: pxToEm(14)
    },
    '& .daterangeinfo': {
      fontSize: pxToEm(14),
      color: themeV2.color.base.gray.dark,
      marginBottom: pxToEm(4)
    },
    '& .actioncolumn': {
      '& .name-actionbtn': {
        display: 'flex',
        flexFlow: 'row wrap',
        '& .button': {
          height: pxToEm(34),
          width: '85px',
          padding: 0,
          margin: pxToEm(4),
          fontSize: pxToEm(12),
          '& .icon': {
            fontSize: pxToEm(12)
          }
        }
      }
    },
    '& .statuscolumn': {
      '& .status': {
        textTransform: 'capitalize'
      },
      '& .icon': {
        color: themeV2.color.base.gray.dark,
        position: 'relative',
        top: pxToEm(2)
      }
    },
    '& .loaderwrapper': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: pxToEm(162)
    },
    '& .name-ratelimiterror': {
      opacity: 0.85
    }
  }
}; 